import { SAVED_FILTER_SET_VISIBILITIES } from '@linearb/linjs-common';
import {
  StyledLabel,
  StyledSectionTitle,
  StyledVisibilitySelector
} from './FilterSetForm.style';
import { FILTER_SET_MODEL } from '../FilterSet.model';
import ErrorMessage from './ErrorMessage';
import { LBLabel, LBRadioGroup, LBRadioGroupItem } from '@linearb/buzz';

const visibilityOptions = [
  {
    value: SAVED_FILTER_SET_VISIBILITIES.PRIVATE,
    label: <StyledLabel>Private (for your eyes only)</StyledLabel>
  },
  {
    value: SAVED_FILTER_SET_VISIBILITIES.PUBLIC,
    label: (
      <StyledLabel>Public (accessible to the whole organization)</StyledLabel>
    )
  }
];

const VisibilitySelector = ({ value, onChange, validator }) => {
  return (
    <StyledVisibilitySelector>
      <StyledSectionTitle>Visibility</StyledSectionTitle>
      <LBRadioGroup name='visibility' onValueChange={onChange} value={value}>
        {visibilityOptions.map(option => (
          <div key={option.value} className='flex flex-row items-center gap-2'>
            <LBRadioGroupItem
              id={option.value}
              value={option.value}
              data-cy={`saved-filter-visibility-${option.value}`}
            />
            <LBLabel htmlFor={option.value}>{option.label}</LBLabel>
          </div>
        ))}
      </LBRadioGroup>
      <ErrorMessage
        validationError={validator.validationError}
        type={FILTER_SET_MODEL.VISIBILITY}
      />
    </StyledVisibilitySelector>
  );
};

export default VisibilitySelector;
